import {cn, Skeleton} from '@chekinapp/ui';

type FieldProps = {
  labelClassName?: string;
};

const SkeletonField = ({labelClassName = 'w-24'}: FieldProps) => (
  <div className="flex flex-col gap-2">
    <Skeleton className={cn('h-3 rounded', labelClassName)} />
    <Skeleton className="h-11 w-full rounded-lg" />
  </div>
);

export const PaymentFormSkeleton = () => (
  <div className="absolute inset-0 flex flex-col gap-4" aria-hidden>
    <SkeletonField labelClassName="w-24" />
    <div className="grid grid-cols-2 gap-3">
      <SkeletonField labelClassName="w-20" />
      <SkeletonField labelClassName="w-24" />
    </div>
    <SkeletonField labelClassName="w-28" />
    <Skeleton className="mt-1 h-12 w-full rounded-xl" />
  </div>
);
